import { render, staticRenderFns } from "./result2904.vue?vue&type=template&id=6922ffce&scoped=true&"
import script from "./result2904.vue?vue&type=script&lang=js&"
export * from "./result2904.vue?vue&type=script&lang=js&"
import style0 from "./result2904.vue?vue&type=style&index=0&id=6922ffce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6922ffce",
  null
  
)

export default component.exports